<template>
  <div class="home">
    <my-header></my-header>
    <div class="main">
      <div class="page">
        <div class="page-left">
          <div
            :class="{ 'page-left-li': true, active: type == '1' }"
            @click="changeType(1)"
          >
            账户设置
          </div>
        </div>
        <div class="page-right">
          <div class="right-block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!-- <el-tab-pane label="基本资料" name="1">基本资料</el-tab-pane> -->
              <el-tab-pane label="账户绑定" name="1">
                <div>绑定后，您可以同时使用以下第三方账号登录720管理平台</div>
                <div class="bind-line">
                  <div :class="{ icon: true, active: hasPhone }">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Page 1</title>
                      <path
                        d="M27.78 29.192c-1.41 1.41-6.665.074-11.857-5.118-5.193-5.193-6.527-10.448-5.12-11.857 1.224-1.221 2.713-3.357 4.946-.577 2.234 2.78 1.135 3.557-.124 4.817-.883.881.957 3.11 2.88 5.034 1.926 1.922 4.152 3.76 5.035 2.882 1.26-1.26 2.038-2.359 4.817-.125 2.779 2.235.645 3.723-.577 4.944zM19.997 0C8.953 0 0 8.953 0 19.998c0 11.044 8.953 19.997 19.998 19.997 11.044 0 19.997-8.953 19.997-19.997C39.995 8.953 31.042 0 19.998 0z"
                        fill-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <span class="">已绑定手机：{{ phoneNumber }}</span>
                  <!-- <a class="">更换手机号</a> -->
                </div>
                <div class="bind-line">
                  <div :class="{ icon: true, active: hasWeixin }">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <title>Page 1</title>
                      <defs>
                        <path id="a" d="M39.995 0H0v39.995h39.995V0z"></path>
                      </defs>
                      <g fill-rule="evenodd">
                        <mask id="b" fill="#fff">
                          <use xlink:href="#a"></use>
                        </mask>
                        <path
                          d="M27.752 19.981c-.489 0-.912.424-.912.945 0 .424.423.847.912.847.652 0 1.14-.423 1.14-.847 0-.521-.488-.945-1.14-.945zm-14.564-6.679c-.684 0-1.4.423-1.4 1.14 0 .685.716 1.14 1.4 1.14.652 0 1.173-.455 1.173-1.14 0-.717-.521-1.14-1.173-1.14zm16.617 14.955l.651 2.346-2.476-1.401c-.945.195-1.857.488-2.802.488-4.366 0-7.82-2.997-7.82-6.711 0-3.714 3.454-6.712 7.82-6.712 4.138 0 7.852 2.998 7.852 6.712 0 2.085-1.4 3.942-3.225 5.278zm-13.587-3.193c-1.205 0-2.085-.196-3.225-.521l-3.291 1.661.945-2.802c-2.313-1.629-3.682-3.681-3.682-6.19 0-4.431 4.17-7.82 9.253-7.82 4.496 0 8.504 2.672 9.286 6.452a4.513 4.513 0 0 0-.88-.098c-4.43 0-7.852 3.323-7.852 7.33 0 .685.098 1.304.26 1.955-.26.033-.553.033-.814.033zM19.998 0C8.953 0 0 8.953 0 19.997c0 11.045 8.953 19.998 19.998 19.998 11.044 0 19.997-8.953 19.997-19.998C39.995 8.953 31.042 0 19.998 0zm-.359 15.583c.717 0 1.173-.456 1.173-1.14 0-.718-.456-1.141-1.173-1.141-.684 0-1.336.423-1.336 1.14 0 .685.652 1.14 1.336 1.14zm2.998 4.398c-.456 0-.913.424-.913.945 0 .424.456.847.913.847.684 0 1.173-.423 1.173-.847 0-.521-.49-.945-1.173-.945z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div
                    class="bind-weixin"
                    @click="openWeixin()"
                    v-if="!hasWeixin"
                  >
                    绑定微信账号
                  </div>
                  <div v-else>
                    微信昵称：{{ nickname }}
                    <span class="bind-weixin" @click="openWeixin()">
                      &nbsp;&nbsp;解绑微信账号
                    </span>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.home {
  height: auto;
  min-width: 1180px;
  background-color: #f8f8f8;
}
.main {
  position: relative;
  margin: 60px auto;
  width: 1180px;
  min-height: calc(100vh - 130px);
}

.page {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 130px);
}

.page-left {
  position: relative;
  width: 210px;
}

.page-left-li {
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
  color: rgb(95, 95, 95);
  cursor: pointer;
  background-color: transparent;
  border-radius: 5px;
}

.page-left-li.active {
  color: rgb(255, 255, 255);
  background-color: rgb(40, 110, 250);
}
.line {
  height: 1px;
  background-color: rgb(222, 222, 222);
  margin-top: 20px;
  margin-bottom: 20px;
}
.word {
  font-size: 12px;
  color: rgb(122, 122, 122);
  line-height: 17px;
}

.page-right {
  position: relative;
  width: 950px;
  min-height: calc(100vh - 130px);
  background-color: white;
}

.right-block {
  display: flex;
  padding: 20px 20px 10px;
  flex-flow: column nowrap;
}
.bind-line {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.bind-line .icon {
  fill: #999;
  margin-right: 20px;
}
.bind-line .icon.active {
  fill: #427afb;
}

.bind-weixin {
  color: #427afb;
  cursor: pointer;
}
</style>
<script>
import https from '../https.js'
import MyHeader from "@/components/header.vue";
export default {
  inject: ['reload'],
  name: '',
  components: {
    MyHeader: MyHeader
  },
  data() {
    return {
      type: 1,
      activeName: '1',
      hasPhone: true,
      hasWeixin: false,
      phoneNumber: '',
      nickname: ''
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  watch: {
  },
  methods: {
    init() {
      var openid = this.$route.query.openid || ''
      https.fetchGet('/api/User/UserInfo').then((res) => {
        console.log(res)
        this.phoneNumber = res.data.phoneNumber
        this.nickname = res.data.nickname
        window.sessionStorage.setItem('model_username',this.phoneNumber);
        window.sessionStorage.setItem('model_nickname',this.nickname);
        if (res.data.nickname != null && res.data.nickname !== '') {
          this.hasWeixin = true
        }
        if (openid !== '') {
          if (this.hasWeixin) {
            https
              .fetchGet('/api/WechatUser/UnbindWechat', {
                openid: openid
              })
              .then((res) => {
                this.$router.replace('/account')
                this.reload()
              })
          } else {
            https
              .fetchGet('/api/WechatUser/BindWechat', {
                openid: openid
              })
              .then((res) => {
                console.log(res.data)
                this.$router.replace('/account')
                this.reload()
              })
          }
        }
      })
    },

    changeType(num) {
      this.type = num
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    openWeixin() {
      window.location.href =
         "https://open.weixin.qq.com/connect/qrconnect?appid=wxc723c5a0742fa2d8&redirect_uri=http%3A%2F%2Fumplatform.z2ww.com%2Fdist%2Findex4.html?response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
    }
  }
}
</script>
